var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "API",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_730",
    "data-name": "Caminho 730",
    d: "M28.576,16.388a1.875,1.875,0,0,0,0-2.651L23.151,8.312,25.87,5.628a1.877,1.877,0,1,0-1.352-1.3L21.825,6.986,16.388,1.549a1.875,1.875,0,0,0-2.651,0L8.312,6.974,5.628,4.255a1.877,1.877,0,1,0-1.3,1.352L6.986,8.3,1.549,13.737a1.875,1.875,0,0,0,0,2.651l5.436,5.436L4.328,24.519a1.873,1.873,0,1,0,1.3,1.352l2.684-2.72,5.425,5.425a1.875,1.875,0,0,0,2.651,0l5.436-5.436L24.519,25.8a1.873,1.873,0,1,0,1.351-1.3l-2.719-2.684ZM15.063,27.25,2.875,15.063,15.063,2.875,27.25,15.063Z",
    transform: "translate(-0.063 -0.063)",
    fill: "#f8f9fa"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 30,
    height: 30,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "api-2",
    "data-name": "api",
    transform: "translate(9.386 12.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_732",
    "data-name": "Caminho 732",
    d: "M4,13H7.509",
    transform: "translate(-4 -9.491)",
    fill: "none",
    stroke: "#f8f9fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_733",
    "data-name": "Caminho 733",
    d: "M12,13.614V8h2.105a1.4,1.4,0,0,1,1.4,1.4v.7a1.4,1.4,0,0,1-1.4,1.4H12",
    transform: "translate(-6.386 -8)",
    fill: "none",
    stroke: "#f8f9fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_734",
    "data-name": "Caminho 734",
    d: "M20,8v5.614",
    transform: "translate(-8.771 -8)",
    fill: "none",
    stroke: "#f8f9fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_735",
    "data-name": "Caminho 735",
    d: "M7.509,13.614V9.755A1.755,1.755,0,1,0,4,9.755v3.86",
    transform: "translate(-4 -8)",
    fill: "none",
    stroke: "#f8f9fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/API.427fea558c3e1d1ddaae7930efb0a59e.svg";
export { ForwardRef as ReactComponent };